import { createSlice } from "@reduxjs/toolkit";
import {
  getPermissionsService,
  getNotificationsService,
  getStatisticsService,
  getAllContactUSerService,
} from "../services/general_service";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  permissions: [],
  notifications: [],
  metaNotifications: null,
  statistics: {},
  contactUserList: [],
  metaContactUser: null,
};

const slice = createSlice({
  name: "permissions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Using builder callback notation
    builder
      .addCase(getPermissionsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.permissions = action.payload?.data?.data;
      })
      .addCase(getPermissionsService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getPermissionsService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getNotificationsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.notifications = action.payload?.data?.data;
        state.metaNotifications = action.payload.data.meta.meta;
      })
      .addCase(getNotificationsService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getNotificationsService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getStatisticsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.statistics = action.payload?.data?.data;
      })
      .addCase(getStatisticsService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getStatisticsService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getAllContactUSerService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.contactUserList = action.payload?.data?.data;
        state.metaContactUser = action.payload.data.meta.meta;
      })
      .addCase(getAllContactUSerService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getAllContactUSerService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      });
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const { } = slice.actions;
